import { AcademyLesson } from './academy-lesson';

export class AcademyModule {
	public id: number;
	public header: string;

	public lessons: AcademyLesson[];

	// progress tracking
	public totalLessons: number;
	public completedLessons: number;

	constructor(data: AcademyModule) {
		Object.assign(this, data);
	}

	public setProgress(completedLessons: Record<number, boolean>) {
		this.totalLessons = this.lessons.length;
		this.completedLessons = this.lessons.filter(l => completedLessons[l.id]).length;
	}
}
